/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Table_IndexInputs */



/**
* | output |
* | --- |
* | "#" |
*
* @param {Tags_Manager_Table_IndexInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_table_index = /** @type {((inputs?: Tags_Manager_Table_IndexInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Table_IndexInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("#")
	if (locale === "de") return /** @type {LocalizedString} */ ("#")
	if (locale === "it") return /** @type {LocalizedString} */ ("#")
	if (locale === "ru") return /** @type {LocalizedString} */ ("#")
	if (locale === "es") return /** @type {LocalizedString} */ ("#")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("#")
	if (locale === "ja") return /** @type {LocalizedString} */ ("#")
	if (locale === "hi") return /** @type {LocalizedString} */ ("#")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("#")
	return /** @type {LocalizedString} */ ("#")
});